import {
  DEFAULT_MANAGER_OWNER_USERNAME,
  LEASING_TEAM_PUBLIC_ID,
  VALIDATION_ERROR_MESSAGES,
} from './constants';

export const getValidationErrors = (transferDetails) => {
  const errors = {};

  if (!transferDetails[LEASING_TEAM_PUBLIC_ID]) {
    errors[LEASING_TEAM_PUBLIC_ID] =
      VALIDATION_ERROR_MESSAGES[LEASING_TEAM_PUBLIC_ID];
  }

  if (!transferDetails[DEFAULT_MANAGER_OWNER_USERNAME]) {
    errors[DEFAULT_MANAGER_OWNER_USERNAME] =
      VALIDATION_ERROR_MESSAGES[DEFAULT_MANAGER_OWNER_USERNAME];
  }

  return Object.keys(errors).length ? errors : null;
};
